import React, {FC, memo} from "react";
import {SvgProps} from "./Svg-types";
import {useSvgContent} from "./Svg-hooks";

const Svg: FC<SvgProps> = memo((props) => {
    const {className, reference, sectionId, svgEncodedBase64} = props;

    const svg = useSvgContent(svgEncodedBase64, sectionId);

    return svg
        ? <div className={className} ref={reference} dangerouslySetInnerHTML={{__html: svg}}/>
        : null
});

export default Svg;



